// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__46UJg","info":"UpdateTermsInfo_info__1Q-zX"};